module.exports = __webpack_public_path__ + "static/media/shopify.b2e2f48c.svg";